<template>
  <div>
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-monitor</v-icon>
      صفحات الموقع
      <back-button />
    </h2>
    <hr class="mt-5 mb-8 header-divider" />

    <v-tabs centered dark background-color="secondary" large height="50">
      <v-tab active-class="secondary darken-1" to="/contents/pages/share-your-pen">
        <v-icon class="ml-3">mdi-pen</v-icon> شارك بقلمك
      </v-tab>
      <v-tab active-class="secondary darken-1" to="/contents/pages/about-us">
        <v-icon class="ml-3">mdi-telescope</v-icon> من نحن
      </v-tab>
    </v-tabs>

    <v-card>
      <v-card-text class="pt-5 pb-0">
        <v-container>
          <v-progress-linear
            v-if="loading"
            color="primary"
            class="my-5"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>

          <div v-else>
            <!-- PAGE PDF -->
            <v-file-input
              dense
              outlined
              label="ملف pdf"
              prepend-icon=""
              append-icon="mdi-file-pdf-box"
              v-model="page.pdf"
            ></v-file-input>

            <hr class="light-divider mb-8" />

            <!-- PAGE SECTIONS -->
            <div
              :key="index"
              v-for="(section, index) in page.sections"
            >
              <!-- TITLE -->
              <v-text-field
                dense
                outlined
                label="عنوان المقطع"
                v-model="page.sections[index].title"
              >
                <template v-slot:append>
                  <v-btn
                    text
                    icon
                    small
                    color="error"
                    @click="page.sections.splice(index, 1)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-text-field>

              <!-- DETAILS -->
              <editor
                :value="page.sections[index].details"
                @input="page.sections[index].details = $event"
              />
            </div>

            <!-- APPEND NEW SECTION -->
            <v-btn
              icon
              large
              color="grey"
              class="d-block mx-auto"
              @click="page.sections.push({ title: '', details: '' })"
            >
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </div>
        </v-container>
      </v-card-text>

      <!-- ACTIONS -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" elevation="1" dark @click="update(page)">حفظ</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>


<script>
import Editor from '@/components/Inputs/Editor';

export default {
  name: 'pages',
  components: { Editor },


  data: function () {
    return {
      page: {
        slug: null,
        pdf: null,
        sections: []
      },

      loading: false,
    };
  },


  watch: {
    '$route.params.page': {
      handler(slug) {
        this.page.slug = slug;
        this.fetchPage();
      },
      immediate: true
    }
  },


  methods: {
    fetchPage() {
      this.loading = true;

      this.axios.get(`/admin/content/pages/${this.page.slug}`)
        .then((response) => {
          this.page.sections = response.data.sections;
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب الصفحة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    update(page) {
      this.loading = true;

      let payload = new FormData;
      if (page.pdf) payload.append('pdf', page.pdf);

      page.sections.forEach((section, index) => {
        payload.append(`sections[${index + 1}][title]`, section.title);
        payload.append(`sections[${index + 1}][details]`, section.details);
      });

      this.axios.post(`/admin/content/pages/${page.slug}`, payload)
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم تعديل الصفحة بنجاح',
            color: 'success'
          });

          this.fetchPage();
        })
        .catch((error) => {
          this.$emit("failure");
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر تعديل الصفحة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
